module.exports = __webpack_public_path__ + "static/img/joystick-1.6bca160.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/joystick-1.svg
// module id = 67bC
// module chunks = 0